import { createSelector } from 'reselect'
import initParametersSelector from '../initParametersSelector'
import config from '../../../config'

const isTrackingEnabledSelector = createSelector(
    initParametersSelector,
    (initParameters): boolean => {
        const enabledBrands = config.TRACKING_ENABLED_BRANDS_LIST
            .toLowerCase()
            .split(',')
            .map(brand => brand.trim())
            .filter(brand => brand.length > 0)

        const contextId = initParameters.contextId?.toLowerCase() || ''

        return enabledBrands.some(brand => contextId.includes(brand))
    },
)

export default isTrackingEnabledSelector
